import React, { useState } from 'react';
import { MapPin, Phone, Clock, Instagram, Facebook } from 'lucide-react';
import { TermsModal, PrivacyModal } from './Modals';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <footer className="bg-cream-dark text-ink py-16 px-6 border-t border-gold/20" data-id="element-95">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-96">
        {/* Brand */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/vyXCETdPnyWa5ugqEt3PN3/heylloyd-image-1777582546768.png" alt="Ingri Lashes Logo" className="h-40 object-contain mb-6" data-id="element-98" />
          <p className="font-serif text-xl text-ink-light italic mb-6" data-id="element-99">
            "Porque tu mirada merece una artista, no una improvisación."
          </p>
          <div className="flex gap-4" data-id="element-100">
            <a href="#" className="w-10 h-10 rounded-full bg-white border border-gold/30 flex items-center justify-center text-gold-dark hover:bg-gold hover:text-white transition-colors shadow-sm" data-id="element-101">
              <Instagram size={18} data-id="element-102" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white border border-gold/30 flex items-center justify-center text-gold-dark hover:bg-gold hover:text-white transition-colors shadow-sm" data-id="element-103">
              <Facebook size={18} data-id="element-104" />
            </a>
          </div>
        </div>

        {/* Contact */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-105">
          <h4 className="font-sans uppercase tracking-widest text-sm text-gold-dark mb-6 font-bold" data-id="element-106">
            Contacto
          </h4>
          <ul className="space-y-4 font-sans text-ink-light text-sm" data-id="element-107">
            <li className="flex items-start gap-3 justify-center md:justify-start" data-id="element-108">
              <MapPin size={18} className="text-gold shrink-0 mt-0.5" data-id="element-109" />
              <span data-id="element-110">
                910 Fairmont Pkwy,
                <br data-id="element-111" />
                Pasadena, TX 77504
              </span>
            </li>
            <li className="flex items-center gap-3 justify-center md:justify-start" data-id="element-112">
              <Phone size={18} className="text-gold shrink-0" data-id="element-113" />
              <span data-id="element-114">+1 (929) 544-1537</span>
            </li>
            <li className="flex items-center gap-3 justify-center md:justify-start" data-id="element-115">
              <Clock size={18} className="text-gold shrink-0" data-id="element-116" />
              <span data-id="element-117">Martes a Sábados · 10am – 4pm</span>
            </li>
          </ul>
        </div>

        {/* Links */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-118">
          <h4 className="font-sans uppercase tracking-widest text-sm text-gold-dark mb-6 font-bold" data-id="element-119">
            Legal
          </h4>
          <ul className="space-y-3 font-sans text-ink-light text-sm" data-id="element-120">
            <li data-id="element-121">
              <button onClick={() => setIsTermsOpen(true)} className="hover:text-gold-dark transition-colors" data-id="element-122">
                Términos y Condiciones
              </button>
            </li>
            <li data-id="element-123">
              <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-gold-dark transition-colors" data-id="element-124">
                Política de Privacidad
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-16 pt-8 border-t border-gold/20 text-center font-sans text-xs text-ink-light/70" data-id="element-125">
        &copy; {new Date().getFullYear()} Pestañas Ingri. Todos los derechos
        reservados.
      </div>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-126" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-127" />
    </footer>;
}